import { ResizeEditorState } from "../../types";

interface Payload {
    payload: number;
}

export const setCustomRatioY = (state: ResizeEditorState, { payload: value }: Payload) => {
    state.crop.customRatioValues.y = value < 0 ? 0 : value;
};